// Logica pura dello Style delle prenotazioni (testabile senza React).

export const FIELD_KEYS = ["email", "allergies", "occasion", "note", "marketing"];
export const FIELD_STATES = ["req", "opt", "off"];
export const CORNERS = { square: "0", round: "10px", pill: "999px" };
export const DEFAULT_FORM = {
  accent: "#B8932F", fcorner: "round", ffont: "", confirm_message: "",
  fields: { email: "opt", allergies: "opt", occasion: "off", note: "opt", marketing: "off" },
};

// Stile del modulo completo di valori predefiniti (come fa il backend).
export const fullForm = (raw) => ({ ...DEFAULT_FORM, ...(raw || {}), fields: { ...DEFAULT_FORM.fields, ...((raw || {}).fields || {}) } });

// Posizione del pulsante sulla copertina, in % dell'area, tenendolo dentro i bordi.
export const dragToPercent = ({ x, y }, rect, btn, margin = 6) => {
  const bw = btn.width / 2;
  const bh = btn.height / 2;
  const px = Math.min(rect.width - bw - margin, Math.max(bw + margin, x - rect.left));
  const py = Math.min(rect.height - bh - margin, Math.max(bh + margin, y - rect.top));
  return { x: +((px / rect.width) * 100).toFixed(1), y: +((py / rect.height) * 100).toFixed(1) };
};

const PRESET_TOP = { top: 14, center: 50, bottom: 86 };

// Dove sta il pulsante: posizione libera se presente, altrimenti la preimpostata.
export const buttonSpot = (b) =>
  typeof b.x === "number" && typeof b.y === "number" ? { left: b.x, top: b.y } : { left: 50, top: PRESET_TOP[b.position] ?? 86 };

// Scegliere una posizione rapida toglie quella libera.
export const withPreset = (b, position) => {
  const { x, y, ...rest } = b;
  return { ...rest, position };
};

// Campi del modulo visibili (nascosti esclusi), nell'ordine del modulo, con l'obbligo.
export const visibleFields = (fields) => FIELD_KEYS.filter((k) => fields[k] !== "off").map((k) => ({ key: k, required: fields[k] === "req" }));
